import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

const selectAppraisalFeePricingState = createSelector(
  getSystem,
  ({ appraisalFeePricing }) => appraisalFeePricing,
);

const selectAppraisalFeePricingsList = createSelector(
  selectAppraisalFeePricingState,
  ({ appraisalFeePricings }) => appraisalFeePricings,
);

export const selectAppraisalFeePricingsValues = createSelector(
  selectAppraisalFeePricingsList,
  Object.values,
);
